import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { RequiredMark } from '@webapp/common/assets/icons';
import { useTextStyle } from '@webapp/common/components/custom-styles';
import { Textfield } from '@webapp/common/components/textfield';
import { UnescapeHtml } from '@webapp/common/lib/utils';

import css from '../question.css';

export const Comment: FC<{
    commentInvalid: boolean;
    commentText?: string;
    onChange: (v: string) => void;
    commentTextHelp: string;
    showMark: boolean;
    markColor?: string;
    className?: string;
    disabled?: boolean;
}> = ({ className, disabled, commentInvalid, commentText, commentTextHelp, showMark, onChange, markColor }) => {
    const { textStyle } = useTextStyle();
    return (
        <div style={textStyle} className={cn(css.comment, className)}>
            <Textfield
                disabled={disabled}
                className={cn(css.commentInput, {
                    [css.commentInvalid]: commentInvalid,
                })}
                placeholder={UnescapeHtml(commentTextHelp || '')}
                style={textStyle}
                value={commentText || ''}
                onChange={onChange}
            />
            {showMark && (
                <span className={cn(css.requiredMarkWrap, css.commentMark)} style={{ color: markColor }}>
                    <RequiredMark />
                </span>
            )}
        </div>
    );
};
